import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { App } from './app/app';
import { provideRouter, Routes } from '@angular/router';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { DashboardComponent } from './app/components/dashboard/dashboard';
import { ContentInventoryComponent } from './app/components/content-inventory/content-inventory';
import { UrlDetailComponent } from './app/components/url-detail/url-detail';
import { ReviewModeComponent } from './app/components/review-mode/review-mode';
import { LoginComponent } from './app/components/login/login';
import { RegisterComponent } from './app/components/register/register';
import { DomainTopicsComponent } from './app/components/domain-topics/domain-topics';
import { KeywordResearchTestComponent } from './app/components/keyword-research-test/keyword-research-test';
import { PageComparisonComponent } from './app/components/page-comparison/page-comparison';
import { CrawlManagementComponent } from './app/components/crawl-management/crawl-management';
import { SetupComponent } from './app/components/setup/setup';
import { ClustersComponent } from './app/components/clusters/clusters';
import { CompetitorFinderComponent } from './app/components/competitor-finder/competitor-finder';
import { ShareViewerComponent } from './app/components/share-viewer/share-viewer';
import { AuthGuard } from './app/guards/auth.guard';
import { featureFlagGuard } from './app/guards/feature-flag.guard';

// Define app routes for standalone routing
const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'inventory', component: ContentInventoryComponent, canActivate: [AuthGuard] },
  // The impact brief worked one URL at a time. Its own route rather than a
  // mode of /dashboard: it is a place an operator goes and stays, the back
  // button should leave it, and `?url=` deep-links the belt to one page.
  { path: 'review', component: ReviewModeComponent, canActivate: [AuthGuard] },
  { path: 'inventory/:url', component: UrlDetailComponent, canActivate: [AuthGuard] },
  { path: 'page-comparison', component: PageComparisonComponent, canActivate: [AuthGuard] },
  { path: 'page-comparison/:executionId', component: PageComparisonComponent, canActivate: [AuthGuard] },

  // Public share link — NO AuthGuard (anyone with the token can view)
  { path: 'share/:token', component: ShareViewerComponent },

  // Experimental routes — guarded by feature flags (redirect to /dashboard when flag is off)
  { path: 'setup', component: SetupComponent, canActivate: [AuthGuard, featureFlagGuard('setup')] },
  { path: 'clusters', component: ClustersComponent, canActivate: [AuthGuard, featureFlagGuard('clusters')] },
  { path: 'domain-topics', component: DomainTopicsComponent, canActivate: [AuthGuard, featureFlagGuard('domainTopics')] },
  { path: 'keyword-research-test', component: KeywordResearchTestComponent, canActivate: [AuthGuard, featureFlagGuard('keywordResearch')] },
  { path: 'crawl-management', component: CrawlManagementComponent, canActivate: [AuthGuard, featureFlagGuard('crawlManagement')] },
  { path: 'competitor-finder', component: CompetitorFinderComponent, canActivate: [AuthGuard, featureFlagGuard('competitorFinder')] },
];

bootstrapApplication(App, {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes)
  ]
}).catch(err => console.error(err));
